import { render } from "./third-register-next.vue?vue&type=template&id=0b883c9c"
import script from "./third-register-next.vue?vue&type=script&lang=js"
export * from "./third-register-next.vue?vue&type=script&lang=js"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__